import { NgModule } from '@angular/core';
import { AmdDialogComponent } from './dialog.component';
var AmdDialogModule = /** @class */ (function () {
    function AmdDialogModule() {
    }
    AmdDialogModule.decorators = [
        { type: NgModule, args: [{
                    exports: [AmdDialogComponent],
                    declarations: [AmdDialogComponent]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdDialogModule.ctorParameters = function () { return []; };
    return AmdDialogModule;
}());
export { AmdDialogModule };
function AmdDialogModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDialogModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDialogModule.ctorParameters;
}
//# sourceMappingURL=dialog.module.js.map
//# sourceMappingURL=dialog.module.js.map
